import * as Yup from "yup";

import { basicEntityFromJson, IBasicEntity } from "../../../core/models";

interface IBudgetBase {
  amount: number;
}

export interface IBudget extends IBudgetBase, IBasicEntity {}

export interface IBudgetForm extends IBudgetBase {}

const budgetCommonValidation = {
  amount: Yup.number().required(),
};

export const budgetFormValidation = Yup.object<IBudgetForm>({
  ...budgetCommonValidation,
});

export const budgetEditFormValidation = Yup.object<IBudgetForm>({
  ...budgetCommonValidation,
});

export const budgetFromJson = (json: any): IBudget => {
  const e: IBudget = {
    ...basicEntityFromJson(json),
    amount: json.amount,
  };

  return e;
};

export const budgetToJson = (form: IBudgetForm) => {
  return {
    amount: form.amount,
  };
};
